<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <FormInput :label="$t('formularios.n_abonado', { abonado: teatro.texto_abonado })" :name="$t('formularios.n_abonado', { abonado: teatro.texto_abonado }).toLowerCase()" type="number" rules="required" v-model="data.subscriber_number" />
        <FormInput :label="$t('formularios.dni')" :name="$t('formularios.dni').toLowerCase()" type="text" rules="required" v-model="data.beneficiary_id_doc" />
        <FormInput :label="$t('formularios.lfp_pin')" :name="$t('formularios.lfp_pin').toLowerCase()" type="number" v-model="data.pin" rules="required|max:4|min:4" />
        <div class="alert alert-danger d-flex align-items-center justify-content-between mt-3 p-1" v-if="error_mensaje">
            <div class="pl-2">
                <b v-if="error_mensaje === 'The given data was invalid.'">{{ $t('perfil.datos_no_validos') }}</b>
                <b v-else>{{ error_mensaje.message }}</b>
            </div>
        </div>

        <div class="row">
            <div class="col-12 d-flex justify-content-between">
                <button type="submit" class="button" name="button" :disabled="loading">{{ $t('formularios.enviar') }}</button>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    export default {
        props: {
            error_mensaje: {
                type: String,
                default: null
            },
            loading: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                data: {}
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if (isValid) {
                    this.$emit('buscarAbonado', this.data);
                }
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        }
    }
</script>